import { render, staticRenderFns } from "./InformationComponent.vue?vue&type=template&id=1f639627&scoped=true"
import script from "./InformationComponent.vue?vue&type=script&lang=js"
export * from "./InformationComponent.vue?vue&type=script&lang=js"
import style0 from "./InformationComponent.vue?vue&type=style&index=0&id=1f639627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f639627",
  null
  
)

export default component.exports